import React, { useMemo } from 'react';
import { OktaAuth, OktaAuthOptions, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';
import { useNavigate } from 'react-router-dom';
import { getConfig } from '../config/runtimeConfig';

interface OktaConfigurationProps {
  children: React.ReactNode;
}

const OktaConfiguration: React.FC<OktaConfigurationProps> = ({ children }) => {
  const navigate = useNavigate();

  const oktaAuth = useMemo(() => {
    const config = getConfig();
    const oktaOptions: OktaAuthOptions = {
      issuer:      config.oktaIssuer,
      clientId:    config.oktaClientId,
      redirectUri: config.oktaRedirectUri || `${window.location.origin}/login/callback`,
      pkce: true,
      scopes: ['phanes:data-onboarding:role','openid', 'profile', 'email', 'offline_access', 'security:provisioning:config:write', 'security:provisioning:config:read'],
      postLogoutRedirectUri: `${window.location.origin}/logout/callback`,
    };

    return new OktaAuth(oktaOptions);
  }, []);

  const restoreOriginalUri = (
    _oktaAuth: OktaAuth,
    originalUri: string
  ): void => {
    const url = originalUri?.length > 0 ? originalUri : '/';
    navigate(toRelativeUrl(url, window.location.origin), { replace: true });
  };

  return (
    <Security
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri}
    >
      {children}
    </Security>
  );
};

export default OktaConfiguration;
